<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 6; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="ap-parentdiv">
			<div class="headtext d-flex align-items-center justify-content-between">
				<div class="heading">
					<span>Access Control</span>
				</div>
			</div>

			<div class="access-control-sub-container">
				<div class="work-align-2 managepage relativeclass">
					<b-tabs content-class="mt-3" v-model="tabIndex">
						<b-tab
							v-if="roles.includes('VIEW_ADMIN')"
							@click="closeTransition(), (tabName = 'users')"
							title="Users"
						>
							<template v-if="isEmpty">
								<div class="text-center">
									<div>
										<img src="../../assets/searchnotfound.svg" alt="" />
									</div>
									<div class="mt-2 text-break">
										No matching results for "{{ searchTopicTest }}"
									</div>
								</div>
							</template>
							<template v-else>
								<!-- new table design starts from here -->
								<div class="userAccess-main-table" id="scrollToUser">
									<div class="userAccess-table-head">
										<div class="userAccess-first-col">Name</div>
										<div class="userAccess-second-col text-center">
											Email ID
										</div>
										<div class="userAccess-third-col text-center">
											Role Type
										</div>
										<div class="userAccess-fourth-col text-center">
											Dashboard
										</div>
										<div class="userAccess-fifth-col text-center">
											Actions
										</div>
									</div>
									<div class="userAccess-table-body">
										<div
											v-for="(row, index) in rowData"
											:key="index"
											class="userAccess-table-row"
											:class="userStatus == 'Edit' ? 'blur' : ''"
										>
											<template v-if="row.view == false">
												<div
													v-once
													class="gridgreencolorDynamic"
													style="background: #5863b3"
												></div>
												<div class="userAccess-first-col">
													<span v-b-tooltip.hover.bottom="row.username">
														{{ row.username | accesscontroluser }}
													</span>
												</div>
												<div class="userAccess-second-col text-center">
													<span v-b-tooltip.hover.bottom="row.email">
														{{ row.email | accesscontroluser }}
													</span>
												</div>
												<div class="userAccess-third-col text-center">
													<span v-b-tooltip.hover.bottom="row.roleName">
														{{ row.roleName | accesscontrolrolesOne }}
													</span>
												</div>
												<div class="userAccess-fourth-col text-center">
													<span
														v-b-tooltip.hover.bottom="
															showDashboardText(row.landingPage)
														"
													>
														{{
															showDashboardText(row.landingPage)
																| accesscontLandingPage
														}}</span
													>
												</div>
												<div
													class="userAccess-fifth-col d-flex align-items-center justify-content-center"
													style="width: 10%"
												>
													<img
														v-if="roles.includes('PUT_USER')"
														@click="
															userStatus == 'Edit' ? '' : copyEditUserData(row)
														"
														:class="userStatus == 'Edit' ? '' : 'pointer'"
														class="mr-3"
														v-b-popover.hover.top="
															userStatus == 'Edit' ? '' : 'Edit'
														"
														src="../../assets/icons/access-pen.svg"
														alt=""
													/>
													<img
														v-if="roles.includes('DELETE_USER')"
														@click="
															userStatus == 'Edit'
																? ''
																: openUserDeleteModal(row)
														"
														:class="userStatus == 'Edit' ? '' : 'pointer'"
														class="mr-3"
														v-b-popover.hover.top="
															userStatus == 'Edit' ? '' : 'Delete'
														"
														src="../../assets/icons/access-delete.svg"
														alt=""
													/>
													<img
														class="pointer"
														v-b-popover.hover.top="'View'"
														@click="viewUser(row)"
														src="../../assets/preview eye.svg"
														alt=""
													/>
												</div>
											</template>
										</div>
									</div>
								</div>
							</template>
						</b-tab>
						<b-tab
							v-if="roles.includes('GET_ROLE')"
							@click="closeTransition(), (tabName = 'roles')"
							title="Roles"
							class="roles"
						>
							<template v-if="isEmptyRoles">
								<div class="text-center">
									<div>
										<img src="../../assets/searchnotfound.svg" alt="" />
									</div>
									<div class="mt-2 text-break">
										No matching results for "{{ searchTopicTest }}"
									</div>
								</div>
							</template>
							<template v-else>
								<!-- new table design starts from here -->
								<div class="userAccess-main-table" id="scrollToRole">
									<div class="userAccess-table-head">
										<div class="roleAccess-first-col">Role Title</div>
										<div class="roleAccess-second-col">
											Role Description
										</div>
										<div class="roleAccess-third-col text-center">
											Actions
										</div>
									</div>
									<div class="userAccess-table-body">
										<div
											v-for="(data, index) in roleData"
											:key="index"
											class="userAccess-table-row"
											:class="roleStatus == 'Edit' ? 'blur' : ''"
										>
											<template v-if="data.view == false">
												<div
													v-once
													class="gridgreencolorDynamic"
													style="background: #5863b3"
												></div>
												<div class="roleAccess-first-col">
													<span v-b-tooltip.hover.bottom="data.roleName">
														{{ data.roleName | accesscontrolroles }}
													</span>
												</div>
												<div class="roleAccess-second-col">
													{{ data.description | accesscontrolrolesdesc }}
												</div>
												<div
													class="roleAccess-third-col d-flex justify-content-center"
												>
													<img
														v-if="roles.includes('PUT_ROLE')"
														@click="
															clearEditRoles(),
																roleStatus == 'Edit' ? '' : copyEditRoles(data)
														"
														:class="roleStatus == 'Edit' ? '' : 'pointer'"
														class="mr-3"
														v-b-popover.hover.top="
															roleStatus == 'Edit' ? '' : 'Edit'
														"
														src="../../assets/icons/access-pen.svg"
														alt=""
													/>
													<img
														v-if="roles.includes('DELETE_ROLE')"
														@click="
															roleStatus == 'Edit'
																? ''
																: openRoleDeleteModal(data)
														"
														:class="roleStatus == 'Edit' ? '' : 'pointer'"
														class="mr-3"
														v-b-popover.hover.top="
															roleStatus == 'Edit' ? '' : 'Delete'
														"
														src="../../assets/icons/access-delete.svg"
														alt=""
													/>
													<img
														class="pointer"
														v-b-popover.hover.top="'View'"
														@click="viewrole(data)"
														src="../../assets/preview eye.svg"
														alt=""
													/>
												</div>
											</template>
										</div>
									</div>
								</div>
							</template>
						</b-tab>
					</b-tabs>
					<div v-if="roles.includes('PUSH_USER')">
						<b-button
							@click="
								(addUserForm = true), (userStatus = 'Add');
								clearUserFormData();
							"
							v-show="tabName == 'users'"
							class="addbtn btn-position"
						>
							<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
							<span class="">Add New User</span>
						</b-button>
					</div>
					<div v-if="roles.includes('PUSH_ROLE')">
						<b-button
							@click="
								(rolecontainer = true),
									(roleStatus = 'Add'),
									clearEditRoles(),
									clearRolesFormData()
							"
							v-show="tabName == 'roles'"
							class="addbtn btn-position"
						>
							<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
							<span class="">Add New Role</span>
						</b-button>
					</div>
				</div>
			</div>

			<!-- add/edit users container starts -->
			<transition name="slide">
				<div v-if="addUserForm" class="accesscontrol-role-main-container">
					<div class="p-3">
						<div class="d-flex align-items-center justify-content-between">
							<div class="position-absolute pointer accesscontrol-backArrow">
								<img
									v-if="userStatus == 'Add'"
									@click="(addUserForm = false), clearUserFormData()"
									src="../../assets/Group 56578backArrow.svg"
									alt=""
								/>

								<img
									v-if="userStatus == 'Edit' && roles.includes('PUT_USER')"
									@click="
										(addUserForm = false),
											(userStatus = 'Add'),
											clearUserFormData()
									"
									src="../../assets/Group 56578backArrow.svg"
									alt=""
								/>
							</div>
							<div class="addrole-heading ml-3">
								<span>
									{{
										userStatus === "Add" ? "Add New User" : "Edit User"
									}}</span
								>
							</div>
							<div class="pointer">
								<img
									v-if="userStatus == 'Add'"
									v-b-popover.hover.top="'Close'"
									@click="(addUserForm = false), clearUserFormData()"
									src="../../assets/Group 2146roundClose.svg"
									alt=""
								/>

								<img
									v-if="userStatus == 'Edit'"
									v-b-popover.hover.top="'Close'"
									@click="
										(addUserForm = false),
											(userStatus = 'Add'),
											clearUserFormData()
									"
									src="../../assets/Group 2146roundClose.svg"
									alt=""
								/>
							</div>
						</div>
						<hr />
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="fieldsetStyle"
										>User Name &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="inputField"
										id="input-1"
										placeholder="Enter User Name"
										v-model.trim="$v.user.name.$model"
										:class="{ error: $v.user.name.$error }"
									>
									</b-form-input>
									<div
										class="access-validationicon"
										v-if="$v.user.name.$dirty && !$v.user.name.required"
										v-b-popover.hover.top.v-danger="{
											content: 'Required',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="access-validationicon"
										v-if="!$v.user.name.maxLength && $v.user.name.required"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not exceed 128 characters',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="access-validationicon"
										v-if="!$v.user.name.alpha && $v.user.name.required"
										v-b-popover.hover.top.v-danger="{
											content: 'Please Enter a Valid name',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label
										:class="
											userStatus == 'Edit'
												? ' modaldisablefieldsetStyle'
												: 'fieldsetStyle'
										"
										>Email &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										:class="
											$v.user.emailid.$error
												? 'error'
												: userStatus == 'Edit'
												? 'access-disableinput'
												: 'inputField'
										"
										id="input-1"
										placeholder="Enter Email"
										v-model.trim="$v.user.emailid.$model"
										:disabled="userStatus == 'Edit'"
										@keyup="emailChange()"
									>
									</b-form-input>
									<div
										class="access-validationicon"
										v-if="$v.user.emailid.$dirty && !$v.user.emailid.required"
										v-b-popover.hover.top.v-danger="{
											content: 'Required',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>

									<div
										class="access-validationicon"
										v-if="!$v.user.emailid.maxLength"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not execed 64 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="access-validationicon"
										v-if="!$v.user.emailid.email"
										v-b-popover.hover.top.v-danger="{
											content: 'Email is invalid',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="position-relative">
									<div
										ref="rec"
										class="topDiv mt-4 pointer"
										@click="roleDropdown()"
									>
										<label class="fieldsetStyle"
											>Select Role(s) &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<div
											class="inputField p-2"
											placeholder="Select Role(s)"
											:class="{ error: $v.roleDropDownValue.$error }"
										>
											<span
												class="cj-noofrecoption"
												v-if="roleDropDownValue.length != 0"
											>
												{{ roleDropDownValue.length }} roles selected
											</span>
											<span class="cj-noofrecoption" v-else>
												Select Role(s)</span
											>
										</div>
										<div
											class="access-validationicon"
											v-if="
												$v.roleDropDownValue.$dirty &&
													!$v.roleDropDownValue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Required',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
									<div
										v-if="selectroleview"
										class="acess-cj-filter-modal"
										ref="recdropdown"
										v-closable="{
											exclude: ['rec', 'recdropdown'],
											handler: 'hideroleDropdown',
										}"
									>
										<div class="relativeclass recinput">
											<div class="access-searchicon-pos">
												<img src="../../assets/icons/inputsearch.svg" alt="" />
											</div>
											<b-form-input
												class="inputField"
												type="text"
												placeholder="Search.."
												v-model="searchrec"
											>
											</b-form-input>

											<b-form-group class="rec-dd-group">
												<b-form-checkbox
													class="qb-dropdown-option-sing pointer m-1"
													size="sm"
													v-for="option in filterrecruiters"
													:key="option.roleName"
													:value="option"
													v-model="$v.roleDropDownValue.$model"
													@change="selectMultipleRoles()"
												>
													{{ option.roleName }}
												</b-form-checkbox>
											</b-form-group>
											<div v-if="filterrecruiters.length == 0">
												No Roles found
											</div>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="fieldsetStyle"
										>Dashboard &nbsp;<span class="asterik">*</span></label
									>
									<b-form-select
										value-field="value"
										text-field="text"
										:options="dashboardOptions"
										v-model="$v.user.roles.landingPage.$model"
										:disabled="roleDropDownValue.length == 0"
										:class="
											$v.user.roles.landingPage.$error
												? 'error'
												: roleDropDownValue.length == 0
												? 'access-disableinput'
												: 'inputField pointer'
										"
									>
									</b-form-select>
									<div
										class="access-validationicon"
										v-if="
											$v.user.roles.landingPage.$dirty &&
												!$v.user.roles.landingPage.required
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Required',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
						<div class="d-flex justify-content-between align-items-center mt-3">
							<div class="prvilagetxt">Privileges</div>
							<div class="previlagesubtxt">
								Privileges for the selected roles:
								<span class="prvilagetxt">{{ newRoleValues.length }}</span>
							</div>
						</div>

						<b-row>
							<b-col cols="12">
								<div class="topDiv newuserdesign">
									<div class="access-background">
										<div class="access-switch">
											<b-row>
												<b-col
													cols="3"
													v-for="option in role_options"
													:key="option.value"
												>
													<b-form-checkbox
														v-model="newRoleValues"
														:key="option.value"
														:value="option.value"
														name="role-check-button"
														switch
														disabled
													>
														{{ option.text }}
													</b-form-checkbox>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>

						<div
							class="mt-3 mr-1 d-flex align-items-center justify-content-end"
						>
							<b-button
								class="addbtn"
								style="width: 100px"
								@click="userStatus === 'Add' ? addUser() : editUser()"
							>
								<span>{{ userStatus === "Add" ? "Confirm" : "Update" }}</span>
							</b-button>
						</div>
					</div>
				</div>
			</transition>
			<!-- add/edit users container end -->

			<!-- view users container starts -->
			<transition name="slide">
				<div v-if="viewusercontainer" class="accesscontrol-role-main-container">
					<div class="p-3">
						<div class="d-flex align-items-center justify-content-between">
							<div
								@click="viewusercontainer = false"
								class="position-absolute pointer accesscontrol-backArrow"
							>
								<img src="../../assets/Group 56578backArrow.svg" alt="" />
							</div>
							<div class="addrole-heading ml-3">View User</div>
							<div @click="viewusercontainer = false" class="pointer">
								<img
									v-if="roles.includes('PUT_USER')"
									v-b-popover.hover.top="'Edit'"
									@click="copyEditUserData(storeuser)"
									src="../../assets/access-pen.svg"
									class="mr-1"
									alt=""
								/>
								<img
									v-b-popover.hover.top="'Close'"
									src="../../assets/Group 2146roundClose.svg"
									alt=""
								/>
							</div>
						</div>
						<hr />
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="disable-fieldsetStyle"
										>User Name &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="disable-inputField"
										id="input-1"
										disabled
										v-model="storeuser.username"
									>
									</b-form-input>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="disable-fieldsetStyle"
										>Email &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="disable-inputField"
										id="input-1"
										disabled
										v-model="storeuser.email"
									>
									</b-form-input>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="disable-fieldsetStyle"
										>Select Role(s) &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="disable-inputField"
										id="input-1"
										disabled
										v-model="storeuser.roleName"
									>
									</b-form-input>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="disable-fieldsetStyle"
										>Dashboard &nbsp;<span class="asterik">*</span></label
									>
									<div
										class="disable-inputField disable-div"
										id="input-1"
										disabled
									>
										{{ showDashboardText(storeuser.landingPage) }}
									</div>
								</div>
							</b-col>
						</b-row>

						<div class="d-flex justify-content-between align-items-center mt-3">
							<div class="prvilagetxt">Privileges</div>
							<div class="previlagesubtxt">
								Privileges for the selected roles:
								<span class="prvilagetxt">{{
									storeuser.permissions.length
								}}</span>
							</div>
						</div>

						<b-row>
							<b-col cols="12">
								<div class="topDiv newuserdesign">
									<div class="access-background">
										<div class="access-switch">
											<b-row>
												<b-col
													cols="3"
													v-for="option in role_options"
													:key="option.value"
												>
													<b-form-checkbox
														v-model="storeuser.permissions"
														:key="option.value"
														:value="option.value"
														name="role-check-button"
														switch
														disabled
													>
														{{ option.text }}
													</b-form-checkbox>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</transition>
			<!-- view users container end -->

			<!-- add/edit roles container starts -->
			<transition name="slide">
				<div v-if="rolecontainer" class="accesscontrol-role-main-container">
					<div class="p-3">
						<div class="d-flex align-items-center justify-content-between">
							<div class="position-absolute pointer accesscontrol-backArrow">
								<img
									v-if="roleStatus == 'Add'"
									@click="rolecontainer = false"
									src="../../assets/Group 56578backArrow.svg"
									alt=""
								/>

								<img
									v-if="roleStatus == 'Edit'"
									@click="
										(rolecontainer = false),
											(roleStatus = 'Add'),
											clearEditRoles()
									"
									src="../../assets/Group 56578backArrow.svg"
									alt=""
								/>
							</div>
							<div class="addrole-heading ml-3">
								<span>
									{{
										roleStatus === "Add" ? "Add New Role" : "Edit Role"
									}}</span
								>
							</div>
							<div class="pointer">
								<img
									v-if="roleStatus == 'Add'"
									v-b-popover.hover.top="'Close'"
									@click="rolecontainer = false"
									src="../../assets/Group 2146roundClose.svg"
									alt=""
								/>

								<img
									v-if="roleStatus == 'Edit'"
									v-b-popover.hover.top="'Close'"
									@click="
										(rolecontainer = false),
											(roleStatus = 'Add'),
											clearEditRoles()
									"
									src="../../assets/Group 2146roundClose.svg"
									alt=""
								/>
							</div>
						</div>
						<hr />

						<b-row>
							<b-col>
								<div class="topDiv mt-3">
									<label
										:class="
											roleStatus == 'Edit'
												? 'modaldisablefieldsetStyle'
												: 'fieldsetStyle'
										"
										>Role Name &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										:class="
											$v.rolesData.roleName.$error
												? 'error'
												: roleStatus == 'Edit'
												? 'access-disableinput'
												: 'inputField form-control'
										"
										placeholder="Enter role name"
										v-model.trim="$v.rolesData.roleName.$model"
										:disabled="roleStatus == 'Edit'"
									>
									</b-form-input>
									<div
										style="position: absolute; top: 5px; right: 2vw"
										v-if="
											$v.rolesData.roleName.$dirty &&
												!$v.rolesData.roleName.required
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Required',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="access-validationicon"
										v-if="
											!$v.rolesData.roleName.alphaSpecial &&
												$v.rolesData.roleName.required
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Please Enter a Valid name',
										}"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="access-validationicon"
										v-if="
											!$v.rolesData.roleName.maxLength &&
												$v.rolesData.roleName.required
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not execed 128 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="fieldsetStyle">Role Description &nbsp;</label>
									<b-form-input
										class="inputField"
										id="input-1"
										placeholder="Enter here..."
										v-model.trim="$v.rolesData.description.$model"
									>
									</b-form-input>
									<div
										class="access-validationicon"
										v-if="!$v.rolesData.description.maxLength"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not execed 250 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="roleaccess-background m-3">
								<div class="access-switch">
									<b-form-checkbox
										v-model="selectAll"
										switch
										@change="AllRolSelect"
									>
										<span class="prevliage-text">All Privileges</span>
									</b-form-checkbox>
								</div>
								<div class="mt-3 d-flex">
									<div class="position-relative search-bar" style="width: 90%">
										<span>
											<img
												class="search-position"
												src="../../assets/search-bar-icon.svg"
												alt=""
											/>
										</span>
										<b-form-input
											class="search-input"
											type="search"
											placeholder="Search"
											@input="checkSelectAll()"
											v-model="searchTerm"
										></b-form-input>
									</div>
									<div
										class="access-control-filterbox ml-3 pointer"
										ref="exp"
										@click="filter()"
									>
										<div>Filter</div>
										<div class="ml-2 d-flex relativeclass">
											<span
												><img src="../../assets/filtericon.svg" alt="" />
											</span>
										</div>
										<div
											class="proct-filter-count mb-3"
											v-if="selectedFilter.length != 0"
										>
											{{ selectedFilter.length }}
										</div>
									</div>
									<div
										v-if="filterview"
										class="cj-filter-modal"
										ref="filterbox"
										v-closable="{
											exclude: ['exp', 'filterbox'],
											handler: 'hidefiltercard',
										}"
									>
										<div
											class="pd-checkboxes-background pointer m-1"
											v-for="(option, index) in filter_option"
											:key="index"
										>
											<b-form-checkbox
												:value="option.value"
												size="sm"
												v-model="selectedFilter"
												@change="checkSelectAll(), updateSubmoduleViews()"
											>
												<div style="color: #6d6d6d">
													{{ option.name }}
												</div>
											</b-form-checkbox>
										</div>
									</div>
								</div>
								<div
									v-if="filteredRoles.length == 0"
									class="
                    h-75
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                  "
								>
									<div>
										<img
											src="../../assets/icons/accesscontrol/emptyprivilage.svg"
											alt=""
										/>
									</div>
									<div class="mt-2 text-break">
										No matching results for "{{ searchTerm }}"
									</div>
								</div>
								<div v-else>
									<div v-for="(module, index1) in filteredRoles" :key="index1">
										<div
											class="modulecards access-outerbox mt-2"
											:class="[
												getAccessColorClass(module),
												module.roleView == true ? 'access-color-full' : '',
												{ 'not-collapsed': !module.collapseOpen },
											]"
											v-b-toggle="'collapse' + index1"
											@click="module.collapseOpen = !module.collapseOpen"
										>
											<div
												class="module-header d-flex justify-content-between align-items-center"
											>
												<div @click.stop class="access-switch">
													<b-form-checkbox
														v-model="module.roleView"
														:key="module.value"
														:value="module.value"
														@change="selectrole(module)"
														switch
													>
														{{ module.name }}
													</b-form-checkbox>
												</div>
												<div class="when-open" v-show="module.collapseOpen">
													<img :src="getAccessColorUpImage(module)" alt="" />
												</div>
												<div class="when-closed" v-show="!module.collapseOpen">
													<img :src="getAccessColorDownImage(module)" alt="" />
												</div>
											</div>
										</div>
										<b-collapse :id="'collapse' + index1">
											<div
												class="access-switch accesscontrol-modulecards pointer when-open"
											>
												<template v-if="module.roles.length == 0">
													<div
														v-for="(submodule, index2) in module.submodules"
														:key="index2"
													>
														<div
															class="d-flex justify-content-between align-items-center access-submodulecards"
															:class="[
																getAccessColorClass(submodule),
																submodule.submodView == true
																	? 'access-color-full'
																	: '',
																{ 'not-collapsed': !submodule.subcollapseOpen },
																module.submodules.length == 0
																	? 'm-3 accesscontrol-closed-br'
																	: 'mb-0 mt-3 ml-3 mr-3 accesscontrol-opened-br',
															]"
															v-b-toggle="'collapse-2' + index2"
															@click="
																submodule.subcollapseOpen = !submodule.subcollapseOpen
															"
														>
															<div @click.stop class="access-switch mt-2">
																<b-form-checkbox
																	v-model="submodule.submodView"
																	:key="submodule.value"
																	:value="submodule.value"
																	@change="selectSubRole(submodule)"
																	switch
																>
																	{{ submodule.name }}
																</b-form-checkbox>
															</div>
															<div
																class="when-open"
																v-show="submodule.subcollapseOpen"
															>
																<img
																	:src="getAccessColorUpImage(submodule)"
																	alt=""
																/>
															</div>
															<div
																class="when-closed"
																v-show="!submodule.subcollapseOpen"
															>
																<img
																	:src="getAccessColorDownImage(submodule)"
																	alt=""
																/>
															</div>
														</div>
														<b-collapse :id="'collapse-2' + index2">
															<div
																class="access-switch access-submodulecards pointer"
																:class="
																	submodule.roles.length == 0
																		? 'm-3 accesscontrol-closed-br'
																		: 'mb-3 mt-0 ml-3 mr-3 accesscontrol-opened-br'
																"
															>
																<b-row>
																	<b-col
																		cols="3"
																		v-for="(subrole, index) in submodule.roles"
																		:key="index"
																		class="mt-2"
																	>
																		<div class="access-switch">
																			<b-form-checkbox
																				v-model="roles_array"
																				:key="subrole.value"
																				:value="subrole.value"
																				@change="selectSubRolVal(subrole)"
																				switch
																			>
																				{{ subrole.text }}
																			</b-form-checkbox>
																		</div>
																	</b-col>
																</b-row>
															</div>
														</b-collapse>
													</div>
												</template>
												<template v-else>
													<div class="access-switch pointer">
														<b-row>
															<b-col
																cols="3"
																v-for="(moduleroles, index) in module.roles"
																:key="index"
																class="mt-2"
															>
																<div class="access-switch">
																	<b-form-checkbox
																		v-model="roles_array"
																		:key="moduleroles.value"
																		:value="moduleroles.value"
																		@change="selectRolVal(moduleroles)"
																		switch
																	>
																		{{ moduleroles.text }}
																	</b-form-checkbox>
																</div>
															</b-col>
														</b-row>
													</div>
												</template>
											</div>
										</b-collapse>
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div
									class="mt-3 mr-4 d-flex align-items-center justify-content-end"
								>
									<b-button
										class="addbtn"
										style="width: 100px"
										@click="roleStatus === 'Add' ? postRoles() : editRoles()"
									>
										<span>{{
											roleStatus === "Add" ? "Confirm" : "Update"
										}}</span>
									</b-button>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</transition>
			<!-- add/edit role container end -->

			<!-- view role container starts -->
			<transition name="slide">
				<div v-if="viewrolecontainer" class="accesscontrol-role-main-container">
					<div class="p-3">
						<div class="d-flex align-items-center justify-content-between">
							<div
								@click="viewrolecontainer = false"
								class="position-absolute pointer accesscontrol-backArrow"
							>
								<img src="../../assets/Group 56578backArrow.svg" alt="" />
							</div>
							<div class="addrole-heading ml-3">View Role</div>
							<div @click="viewrolecontainer = false" class="pointer">
								<img
									v-if="roles.includes('PUT_ROLE')"
									v-b-popover.hover.top="'Edit'"
									@click="copyEditRoles(storeData)"
									src="../../assets/access-pen.svg"
									class="mr-1"
									alt=""
								/>
								<img
									v-b-popover.hover.top="'Close'"
									src="../../assets/Group 2146roundClose.svg"
									alt=""
								/>
							</div>
						</div>
						<hr />
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="disable-fieldsetStyle"
										>Role Name &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="disable-inputField"
										id="input-1"
										disabled
										v-model="storeData.roleName"
									>
									</b-form-input>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-4">
									<label class="disable-fieldsetStyle"
										>Description &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="disable-inputField"
										id="input-1"
										disabled
										v-model="storeData.description"
									>
									</b-form-input>
								</div>
							</b-col>
						</b-row>

						<div class="d-flex justify-content-between align-items-center mt-3">
							<div class="prvilagetxt">Privileges</div>
							<div class="previlagesubtxt">
								Privileges for the selected roles:
								<span class="prvilagetxt">{{ storeData.roles.length }}</span>
							</div>
						</div>

						<b-row>
							<b-col cols="12">
								<div class="topDiv newuserdesign">
									<div class="vr-access-background">
										<div class="access-switch">
											<b-row>
												<b-col
													cols="3"
													v-for="option in role_options"
													:key="option.value"
												>
													<b-form-checkbox
														v-model="storeData.roles"
														:key="option.value"
														:value="option.value"
														name="role-check-button"
														switch
														disabled
													>
														{{ option.text }}
													</b-form-checkbox>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</transition>
			<!-- view role container end -->
		</div>

		<!-----------------  Roles Delete Popup starts -------->
		<b-modal id="delete-role-modal" centered hide-footer hide-header>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('delete-role-modal')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span
					>Are you sure you want to delete "{{ deleteRolesData.roleName }}"
					?</span
				>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteRoles(deleteRolesData)"
					>Delete</b-button
				>
			</div>
		</b-modal>

		<!----------------- Roles Delete Popup ends -------->

		<!-----------------  User Delete Popup starts -------->
		<b-modal id="delete-user-modal" centered hide-footer hide-header>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('delete-user-modal')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span
					>Are you sure you want to delete "{{ deleteUserData.username }}"
					?</span
				>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteUser(deleteUserData)"
					>Delete</b-button
				>
			</div>
		</b-modal>

		<!----------------- User Delete Popup ends -------->
	</div>
</template>

<script>
// User Api Functions
import {
	postAccessData,
	getAccessData,
	deleteAccessData,
	putAccessData,
	postRoles,
	getRolesDetails,
	putRoles,
	deleteRoles,
	userToLicenseData,
} from "../../utils/apiFunctions.js";

// Roles Api Functions
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { mapGetters } from "vuex";
import { required, email, helpers, maxLength } from "vuelidate/lib/validators";
import toast from "../mixin/toast";
export default {
	name: "AccessPanel",
	components: {
		Spinner,
	},
	data() {
		return {
			tabName: "users",
			roles_options_checked: false,
			tabIndex: 0,
			userStatus: "",
			roleStatus: "",
			selectedUserID: "",
			rolecontainer: false,
			viewrolecontainer: false,
			viewusercontainer: false,
			selectAll: false,
			filterview: false,
			selectroleview: false,
			searchrec: "",
			searchTerm: "",
			LoaderStatus: false,
			addUserForm: false,
			checked: true,
			addRoleForm: false,
			allSelected: false,
			indeterminate: false,
			allRoleCheck: false,
			rec: false,
			deleteData: {},
			deleteRolesData: {},
			deleteUserData: {},
			user: {
				name: "",
				emailid: "",
				summary: "",
				roles: {
					roleName: "",
					description: "",
					roles: [],
					landingPage: "",
				},
			},
			rolesData: {
				roleName: "",
				description: "",
				licenseKey: "",
				project: "assessment",
				projectPermission: "1",
				roles: [],
			},
			roleData: [],
			rowData: [],
			rolesoptions: [],
			selectedFilter: [],
			roles_array: [],
			user_array: [],
			roleDropDownValue: [],
			newRoleValues: [],
			dashboardOptions: [],
			role_options: [
				{ text: "View_Topic", value: "GET_TOPIC" },
				{ text: "Add_Topic", value: "PUSH_TOPIC" },
				{ text: "Edit_Topic", value: "PUT_TOPIC" },
				{ text: "Delete_Topic", value: "DELETE_TOPIC" },
				{ text: "Activate_Topic", value: "ACTIVATE_TOPIC" },
				{ text: "View_Test", value: "GET_TEST" },
				{ text: "Add_Test", value: "PUSH_TEST" },
				{ text: "Edit_Test", value: "PUT_TEST" },
				{ text: "Delete_Test", value: "DELETE_TEST" },
				{ text: "Clone_Test", value: "CLONE_TEST" },
				{ text: "Activate_Test", value: "ACTIVATE_TEST" },
				{ text: "View_Test_Config", value: "GET_CONFIG" },
				{ text: "Edit_Test_Config", value: "PUT_CONFIG" },
				{ text: "View_Section", value: "GET_SECTION" },
				{ text: "Add_Section", value: "PUSH_SECTION" },
				{ text: "Edit_Section", value: "PUT_SECTION" },
				{ text: "Delete_Section", value: "DELETE_SECTION" },
				{ text: "View_Question", value: "GET_QUESTION" },
				{ text: "Add_Question", value: "PUSH_QUESTION" },
				{ text: "Edit_Question", value: "PUT_QUESTION" },
				{ text: "Delete_Question", value: "DELETE_QUESTION" },
				// { text: "Get_Share", value: "GET_SHARE" },
				// { text: "Add_Share", value: "PUSH_SHARE" },
				// { text: "Edit_Share", value: "PUT_SHARE" },
				// { text: "Delete_Share", value: "DELETE_SHARE" },
				{ text: "View_Individual", value: "GET_TEST_INDIVIDUAL" },
				{ text: "Add_Individual", value: "PUSH_TEST_INDIVIDUAL" },
				{ text: "Edit_Individual", value: "PUT_TEST_INDIVIDUAL" },
				{ text: "Delete_Individual", value: "DELETE_TEST_INDIVIDUAL" },
				{ text: "View_Group", value: "GET_TEST_GROUP" },
				{ text: "Add_Group", value: "PUSH_TEST_GROUP" },
				{ text: "Edit_Group", value: "PUT_TEST_GROUP" },
				{ text: "Delete_Group", value: "DELETE_TEST_GROUP" },
				{ text: "Tag Evalutor", value: "TAG_EVALUATOR" },
				{ text: "View Test Config_Page", value: "GET_TEST_CONFIG" },
				{ text: "Add Test Config_Page", value: "PUSH_TEST_CONFIG" },
				{ text: "Edit Test Config_Page", value: "PUT_TEST_CONFIG" },
				{ text: "Delete Test Config_Page", value: "DELETE_TEST_CONFIG" },
				{ text: "View User", value: "VIEW_ADMIN" },
				{ text: "Add User", value: "PUSH_USER" },
				{ text: "Edit User", value: "PUT_USER" },
				{ text: "Delete User", value: "DELETE_USER" },
				{ text: "View Role", value: "GET_ROLE" },
				{ text: "Add Role", value: "PUSH_ROLE" },
				{ text: "Edit Role", value: "PUT_ROLE" },
				{ text: "Delete Role", value: "DELETE_ROLE" },

				{ text: "View_QuestionBank", value: "GET_QUESTION_BANK" },
				{ text: "Add_QuestionBank", value: "PUSH_QUESTION_BANK" },
				{ text: "Edit_QuestionBank", value: "PUT_QUESTION_BANK" },
				{ text: "Delete_QuestionBank", value: "DELETE_QUESTION_BANK" },
				{ text: "View_Auto_Test", value: "GET_AUTOGENERATE" },
				{ text: "Add_Auto_Test", value: "PUSH_AUTO_TEST" },
				{ text: "Edit_Auto_Test", value: "PUT_AUTO_TEST" },
				{ text: "Delete_Auto_Test", value: "DELETE_AUTO_TEST" },
				{ text: "Activate_Auto_Test", value: "ACTIVATE_AUTO_TEST" },
				{ text: "View_Auto_Test_Config", value: "GET_AUTO_CONFIG" },
				{ text: "Edit_Auto_Test_Config", value: "PUT_AUTO_CONFIG" },
				{ text: "View_Auto_Section", value: "GET_AUTO_SECTION" },
				{ text: "Add_Auto_Section", value: "PUSH_AUTO_SECTION" },
				{ text: "Edit_Auto_Section", value: "PUT_AUTO_SECTION" },
				{ text: "Delete_Auto_Section", value: "DELETE_AUTO_SECTION" },
				{ text: "View_Auto_Question", value: "GET_AUTO_QUESTION" },
				{ text: "Add_Auto_Question", value: "PUSH_AUTO_QUESTION" },
				{ text: "Edit_Auto_Question", value: "PUT_AUTO_QUESTION" },
				{ text: "Delete_Auto_Question", value: "DELETE_AUTO_QUESTION" },
				// { text: "Get_Auto_Share", value: "GET_AUTO_SHARE" },
				// { text: "Add_Auto_Share", value: "PUSH_AUTO_SHARE" },
				// { text: "Edit_Auto_Share", value: "PUT_AUTO_SHARE" },
				// { text: "Delete_Auto_Share", value: "DELETE_AUTO_SHARE" },
				{ text: "View_Individual", value: "GET_AUTO_INDIVIDUAL" },
				{ text: "Add_Individual", value: "PUSH_AUTO_INDIVIDUAL" },
				{ text: "Edit_Individual", value: "PUT_AUTO_INDIVIDUAL" },
				{ text: "Delete_Individual", value: "DELETE_AUTO_INDIVIDUAL" },
				{ text: "View_Group", value: "GET_AUTO_GROUP" },
				{ text: "Add_Group", value: "PUSH_AUTO_GROUP" },
				{ text: "Edit_Group", value: "PUT_AUTO_GROUP" },
				{ text: "Delete_Group", value: "DELETE_AUTO_GROUP" },
				{ text: "Tag Evaluator", value: "TAG_AUTO_EVALUATOR" },
				{ text: "View AutoTest Config_Page", value: "GET_AUTO_TEST_CONFIG" },
				{ text: "Add AutoTest Config_Page", value: "PUSH_AUTO_TEST_CONFIG" },
				{ text: "Edit AutoTest Config_Page", value: "PUT_AUTO_TEST_CONFIG" },
				{
					text: "Delete AutoTest Config_Page",
					value: "DELETE_AUTO_TEST_CONFIG",
				},
				{ text: "View_Individual", value: "GET_INDIVIDUAL" },
				{ text: "Add_Individual", value: "PUSH_INDIVIDUAL" },
				{ text: "Edit_Individual", value: "PUT_INDIVIDUAL" },
				{ text: "Delete_Individual", value: "DELETE_INDIVIDUAL" },
				{ text: "View_Group", value: "GET_GROUP" },
				{ text: "Add_Group", value: "PUSH_GROUP" },
				{ text: "Edit_Group", value: "PUT_GROUP" },
				{ text: "Delete_Group", value: "DELETE_GROUP" },
				{ text: "View_Proctoring", value: "GET_PROCTORING" },
				{ text: "View_Proctoring_Test", value: "GET_PROCTORING_TEST" },
				{ text: "View_Proctoring_Details", value: "GET_PROCTORING_DETAILS" },
				{ text: "Evaluate_Test", value: "EVALUATE_TEST" },
				{ text: "View_Reports", value: "GET_REPORTS" },
				{ text: "View_Evaluator", value: "GET_EVALUATOR" },
				{ text: "Add_Evaluator", value: "PUSH_EVALUATOR" },
				{ text: "Edit_Evaluator", value: "PUT_EVALUATOR" },
				{ text: "Delete_Evaluator", value: "DELETE_EVALUATOR" },
				{ text: "View_CodingTest", value: "GET_CODING_TEST" },
				{ text: "Add_CodingTest", value: "PUSH_CODING_TEST" },
				{ text: "Edit_CodingTest", value: "PUT_CODING_TEST" },
				{ text: "Delete_CodingTest", value: "DELETE_CODING_TEST" },
				{ text: "View Transactions", value: "GET_TRANSACTION" },
				{ text: "Hire3x Wallet", value: "HIRE3X_WALLET" },
			],
			allRoles: [
				{
					name: "Home",
					roles: [],
					submodules: [
						{
							name: "Topics",
							roles: [
								{ text: "View_Topic", value: "GET_TOPIC", type: "View" },
								{ text: "Add_Topic", value: "PUSH_TOPIC", type: "Add" },
								{ text: "Edit_Topic", value: "PUT_TOPIC", type: "Edit" },
								{ text: "Delete_Topic", value: "DELETE_TOPIC", type: "Delete" },
								{
									text: "Activate_Topic",
									value: "ACTIVATE_TOPIC",
									type: "Add",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Test",
							roles: [
								{ text: "View_Test", value: "GET_TEST", type: "View" },
								{ text: "Add_Test", value: "PUSH_TEST", type: "Add" },
								{ text: "Edit_Test", value: "PUT_TEST", type: "Edit" },
								{ text: "Delete_Test", value: "DELETE_TEST", type: "Delete" },
								{ text: "Clone_Test", value: "CLONE_TEST", type: "Add" },
								{ text: "Activate_Test", value: "ACTIVATE_TEST", type: "Add" },
								{ text: "View_Test_Config", value: "GET_CONFIG", type: "View" },
								{ text: "Edit_Test_Config", value: "PUT_CONFIG", type: "Edit" },
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Section",
							roles: [
								{ text: "View_Section", value: "GET_SECTION", type: "View" },
								{ text: "Add_Section", value: "PUSH_SECTION", type: "Add" },
								{ text: "Edit_Section", value: "PUT_SECTION", type: "Edit" },
								{
									text: "Delete_Section",
									value: "DELETE_SECTION",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "QP Builder",
							roles: [
								{ text: "View_Question", value: "GET_QUESTION", type: "View" },
								{ text: "Add_Question", value: "PUSH_QUESTION", type: "Add" },
								{ text: "Edit_Question", value: "PUT_QUESTION", type: "Edit" },
								{
									text: "Delete_Question",
									value: "DELETE_QUESTION",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Share With People",
							roles: [
								// {
								//   text: "Get_Share",
								//   value: "GET_SHARE",
								//   type: "View"
								// },
								// {
								//   text: "Add_Share",
								//   value: "PUSH_SHARE",
								//   type: "Add"
								// },
								// {
								//   text: "Edit_Share",
								//   value: "PUT_SHARE",
								//   type: "Edit"
								// },
								// {
								//   text: "Delete_Share",
								//   value: "DELETE_SHARE",
								//   type: "Delete"
								// },
								{
									text: "View_Individual",
									value: "GET_TEST_INDIVIDUAL",
									type: "View",
								},
								{
									text: "Add_Individual",
									value: "PUSH_TEST_INDIVIDUAL",
									type: "Add",
								},
								{
									text: "Edit_Individual",
									value: "PUT_TEST_INDIVIDUAL",
									type: "Edit",
								},
								{
									text: "Delete_Individual",
									value: "DELETE_TEST_INDIVIDUAL",
									type: "Delete",
								},
								{ text: "View_Group", value: "GET_TEST_GROUP", type: "View" },
								{ text: "Add_Group", value: "PUSH_TEST_GROUP", type: "Add" },
								{ text: "Edit_Group", value: "PUT_TEST_GROUP", type: "Edit" },
								{
									text: "Delete_Group",
									value: "DELETE_TEST_GROUP",
									type: "Delete",
								},
								{ text: "Tag Evaluator", value: "TAG_EVALUATOR", type: "Add" },
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Configure",
							roles: [
								{
									text: "View Test Config_Page",
									value: "GET_TEST_CONFIG",
									type: "View",
								},
								{
									text: "Add Test Config_Page",
									value: "PUSH_TEST_CONFIG",
									type: "Add",
								},
								{
									text: "Edit Test Config_Page",
									value: "PUT_TEST_CONFIG",
									type: "Edit",
								},
								{
									text: "Delete Test Config_Page",
									value: "DELETE_TEST_CONFIG",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
					],
					roleView: false,
					collapseOpen: false,
				},
				{
					name: "Individual/Group",
					roles: [],
					submodules: [
						{
							name: "Individual",
							roles: [
								{
									text: "View_Individual",
									value: "GET_INDIVIDUAL",
									type: "View",
								},
								{
									text: "Add_Individual",
									value: "PUSH_INDIVIDUAL",
									type: "Add",
								},
								{
									text: "Edit_Individual",
									value: "PUT_INDIVIDUAL",
									type: "Edit",
								},
								{
									text: "Delete_Individual",
									value: "DELETE_INDIVIDUAL",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Group",
							roles: [
								{ text: "View_Group", value: "GET_GROUP", type: "View" },
								{ text: "Add_Group", value: "PUSH_GROUP", type: "Add" },
								{ text: "Edit_Group", value: "PUT_GROUP", type: "Edit" },
								{ text: "Delete_Group", value: "DELETE_GROUP", type: "Delete" },
							],
							submodView: false,
							subcollapseOpen: false,
						},
					],
					roleView: false,
					collapseOpen: false,
				},
				{
					name: "Auto Generate",
					roles: [],
					submodules: [
						{
							name: "Auto Generate Test",
							roles: [
								{
									text: "View_Auto_Test",
									value: "GET_AUTOGENERATE",
									type: "View",
								},
								{ text: "Add_Auto_Test", value: "PUSH_AUTO_TEST", type: "Add" },
								{
									text: "Edit_Auto_Test",
									value: "PUT_AUTO_TEST",
									type: "Edit",
								},
								{
									text: "Delete_Auto_Test",
									value: "DELETE_AUTO_TEST",
									type: "Delete",
								},
								{
									text: "View_Auto_Test_Config",
									value: "GET_AUTO_CONFIG",
									type: "View",
								},
								{
									text: "Edit_Auto_Test_Config",
									value: "PUT_AUTO_CONFIG",
									type: "Edit",
								},
								{
									text: "Activate_Auto_Test",
									value: "ACTIVATE_AUTO_TEST",
									type: "Add",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Auto Section",
							roles: [
								{
									text: "View_Auto_Section",
									value: "GET_AUTO_SECTION",
									type: "View",
								},
								{
									text: "Add_Auto_Section",
									value: "PUSH_AUTO_SECTION",
									type: "Add",
								},
								{
									text: "Edit_Auto_Section",
									value: "PUT_AUTO_SECTION",
									type: "Edit",
								},
								{
									text: "Delete_Auto_Section",
									value: "DELETE_AUTO_SECTION",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Auto QP Builder",
							roles: [
								{
									text: "View_Auto_Question",
									value: "GET_AUTO_QUESTION",
									type: "View",
								},
								{
									text: "Add_Auto_Question",
									value: "PUSH_AUTO_QUESTION",
									type: "Add",
								},
								{
									text: "Edit_Auto_Question",
									value: "PUT_AUTO_QUESTION",
									type: "Edit",
								},
								{
									text: "Delete_Auto_Question",
									value: "DELETE_AUTO_QUESTION",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Auto Share-With-People",
							roles: [
								// {
								//   text: "Get_Auto_Share",
								//   value: "GET_AUTO_SHARE",
								//   type: "View"
								// },
								// {
								//   text: "Add_Auto_Share",
								//   value: "PUSH_AUTO_SHARE",
								//   type: "Add"
								// },
								// {
								//   text: "Edit_Auto_Share",
								//   value: "PUT_AUTO_SHARE",
								//   type: "Edit"
								// },
								// {
								//   text: "Delete_Auto_Share",
								//   value: "DELETE_AUTO_SHARE",
								//   type: "Delete"
								// },
								{
									text: "View_Individual",
									value: "GET_AUTO_INDIVIDUAL",
									type: "View",
								},
								{
									text: "Add_Individual",
									value: "PUSH_AUTO_INDIVIDUAL",
									type: "Add",
								},
								{
									text: "Edit_Individual",
									value: "PUT_AUTO_INDIVIDUAL",
									type: "Edit",
								},
								{
									text: "Delete_Individual",
									value: "DELETE_AUTO_INDIVIDUAL",
									type: "Delete",
								},
								{ text: "View_Group", value: "GET_AUTO_GROUP", type: "View" },
								{ text: "Add_Group", value: "PUSH_AUTO_GROUP", type: "Add" },
								{ text: "Edit_Group", value: "PUT_AUTO_GROUP", type: "Edit" },
								{
									text: "Delete_Group",
									value: "DELETE_AUTO_GROUP",
									type: "Delete",
								},
								{
									text: "Tag Evaluator",
									value: "TAG_AUTO_EVALUATOR",
									type: "Add",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Auto-Configure",
							roles: [
								{
									text: "View AutoTest Config_Page",
									value: "GET_AUTO_TEST_CONFIG",
									type: "View",
								},
								{
									text: "Add AutoTest Config_Page",
									value: "PUSH_AUTO_TEST_CONFIG",
									type: "Add",
								},
								{
									text: "Edit AutoTest Config_Page",
									value: "PUT_AUTO_TEST_CONFIG",
									type: "Edit",
								},
								{
									text: "Delete AutoTest Config_Page",
									value: "DELETE_AUTO_TEST_CONFIG",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
					],
					roleView: false,
					collapseOpen: false,
				},
				{
					name: "Permissions",
					roles: [],
					submodules: [
						{
							name: "User",
							roles: [
								{ text: "View User", value: "VIEW_ADMIN", type: "View" },
								{ text: "Add User", value: "PUSH_USER", type: "Add" },
								{ text: "Edit User", value: "PUT_USER", type: "Edit" },
								{
									text: "Delete User",
									value: "DELETE_USER",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Role",
							roles: [
								{ text: "View Role", value: "GET_ROLE", type: "View" },
								{ text: "Add Role", value: "PUSH_ROLE", type: "Add" },
								{ text: "Edit Role", value: "PUT_ROLE", type: "Edit" },
								{
									text: "Delete Role",
									value: "DELETE_ROLE",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Evaluator",
							roles: [
								{
									text: "View_Evaluator",
									value: "GET_EVALUATOR",
									type: "View",
								},
								{ text: "Add_Evaluator", value: "PUSH_EVALUATOR", type: "Add" },
								{
									text: "Edit_Evaluator",
									value: "PUT_EVALUATOR",
									type: "Edit",
								},
								{
									text: "Delete_Evaluator",
									value: "DELETE_EVALUATOR",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
					],
					roleView: false,
					collapseOpen: false,
				},
				{
					name: "Question Bank",
					roles: [],
					submodules: [
						{
							name: "Question Bank",
							roles: [
								{
									text: "View_QuestionBank",
									value: "GET_QUESTION_BANK",
									type: "View",
								},
								{
									text: "Add_QuestionBank",
									value: "PUSH_QUESTION_BANK",
									type: "Add",
								},
								{
									text: "Edit_QuestionBank",
									value: "PUT_QUESTION_BANK",
									type: "Edit",
								},
								{
									text: "Delete_QuestionBank",
									value: "DELETE_QUESTION_BANK",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
						{
							name: "Coding Test",
							roles: [
								{
									text: "View_CodingTest",
									value: "GET_CODING_TEST",
									type: "View",
								},
								{
									text: "Add_CodingTest",
									value: "PUSH_CODING_TEST",
									type: "Add",
								},
								{
									text: "Edit_CodingTest",
									value: "PUT_CODING_TEST",
									type: "Edit",
								},
								{
									text: "Delete_CodingTest",
									value: "DELETE_CODING_TEST",
									type: "Delete",
								},
							],
							submodView: false,
							subcollapseOpen: false,
						},
					],
					roleView: false,
					collapseOpen: false,
				},
				{
					name: "Proctoring",
					roles: [
						{ text: "View_Proctoring", value: "GET_PROCTORING", type: "View" },
						{
							text: "View_Proctoring_Test",
							value: "GET_PROCTORING_TEST",
							type: "View",
						},
						{
							text: "View_Proctoring_Details",
							value: "GET_PROCTORING_DETAILS",
							type: "View",
						},
						{ text: "Evaluate_Test", value: "EVALUATE_TEST", type: "Add" },
					],
					roleView: false,
					collapseOpen: false,
				},
				{
					name: "Reports",
					roles: [{ text: "View_Reports", value: "GET_REPORTS", type: "View" }],
					roleView: false,
					collapseOpen: false,
				},
				{
					name: "Transactions",
					roles: [
						{ text: "View Transactions", value: "GET_TRANSACTION", type: "View" },
						{ text: "Hire3x Wallet", value: "HIRE3X_WALLET", type: "View" },
					],
					roleView: false,
					collapseOpen: false,
				},
			],
			filter_option: [
				{ name: "Add Permission", value: "Add" },
				{ name: "Edit Permission", value: "Edit" },
				{ name: "View Permission", value: "View" },
				{ name: "Delete Permission", value: "Delete" },
			],
		};
	},
	mixins: [toast],
	computed: {
		...mapGetters(["roles"]),
		...mapGetters("userVUEX", {
			licenseKey: "getlicenseKey",
		}),
		userNumber() {
			return this.rowData.length + 1;
		},
		...mapGetters("searchVUEX", {
			searchTopicTest: "getSearchTopicTest",
			// filter: "filterinfo"
		}),
		isEmpty() {
			let temp;
			if (this.searchTopicTest == "") {
				temp = false;
			} else if (this.searchTopicTest != "" && this.rowData.length == 0) {
				temp = true;
			}
			return temp;
		},
		isEmptyRoles() {
			let temp;
			if (this.searchTopicTest == "") {
				temp = false;
			} else if (this.searchTopicTest != "" && this.roleData.length == 0) {
				temp = true;
			}
			return temp;
		},
		filterrecruiters() {
			return this.rolesoptions.filter((data) => {
				return (
					!this.searchrec ||
					data.roleName.toLowerCase().includes(this.searchrec.toLowerCase())
				);
			});
		},

		filteredRoles() {
			const filteredModules = this.allRoles.filter((module) => {
				// Check if module name matches the search term
				if (module.name.toLowerCase().includes(this.searchTerm.toLowerCase())) {
					return true;
				}

				// Check if any role text matches the search term
				if (this.checkRoleMatch(module)) {
					return true;
				}

				// Check if any submodule name or role text matches the search term
				if (module.submodules && Array.isArray(module.submodules)) {
					if (
						module.submodules.some((submodule) =>
							submodule.name
								.toLowerCase()
								.includes(this.searchTerm.toLowerCase())
						)
					) {
						return true;
					}
					if (
						module.submodules.some(
							(submodule) =>
								submodule.roles &&
								Array.isArray(submodule.roles) &&
								submodule.roles.some((role) =>
									role.text
										.toLowerCase()
										.includes(this.searchTerm.toLowerCase())
								)
						)
					) {
						return true;
					}
				}

				return false;
			});

			// Filter roles based on selectedFilter if it is not empty
			if (this.selectedFilter.length > 0) {
				return this.filterRolesonSelectedFilter(filteredModules);
			}

			return filteredModules;
		},

		selectedChildCount() {
			let count = 0;
			this.filteredRoles.forEach((module) => {
				if (module.roles.length > 0) {
					count += module.roles.filter((role) =>
						this.roles_array.includes(role.value)
					).length;
				} else {
					module.submodules.forEach((submodule) => {
						count += submodule.roles.filter((role) =>
							this.roles_array.includes(role.value)
						).length;
					});
				}
			});
			return count;
		},
		selectedRoleCount() {
			let count = 0;
			this.filteredRoles.forEach((module) => {
				if (module.roles.length > 0) {
					const roleCount = module.roles.filter((role) =>
						this.roles_array.includes(role.value)
					).length;
					if (roleCount === module.roles.length) {
						count++;
					}
				} else {
					const submoduleCount = module.submodules.filter((submodule) =>
						submodule.roles.every((role) =>
							this.roles_array.includes(role.value)
						)
					).length;
					if (submoduleCount === module.submodules.length) {
						count++;
					}
				}
			});
			return count;
		},
	},
	watch: {
		//tabchange with selection in newsidebar
		$route() {
			this.setTabIndex();
		},
		searchTopicTest(newValue, oldValue) {
			this.LoaderStatus = true;
			if (newValue != oldValue) {
				if (this.tabName == "users") {
					this.getAccessData();
				} else {
					this.getRolesDetails();
				}
			}
		},
		tabName(newValue) {
			let status = newValue;
			this.$router.push({
				name: "AccessControl",
				query: {
					status: status,
				},
			});
		},
		// tabIndex(newValue, oldValue) {
		//   console.log(newValue)
		//   if (newValue != oldValue) {
		//     let status;
		//     // Map the tabIndex value to the corresponding status
		//     switch (newValue) {
		//       case 0:
		//         status = "users";
		//         this.getAccessData();
		//         break;
		//       case 1:
		//         status = "roles";
		//         this.getRolesDetails();
		//         break;
		//       default:
		//         status = "users";
		//         this.getAccessData();
		//         break;
		//     }
		//     // Update the route with the new status query parameter
		//     this.$router.push({
		//       name: "AccessControl",
		//       query: {
		//         status: status
		//       }
		//     });
		//   }
		// },
		selectedChildCount() {
			const selectedCount = this.selectedChildCount;
			const totalRoles = this.filteredRoles.reduce((total, module) => {
				return (
					total +
					(module.roles.length ||
						module.submodules.reduce(
							(subTotal, submodule) => subTotal + submodule.roles.length,
							0
						))
				);
			}, 0);
			this.selectAll = selectedCount === totalRoles;
		},
		selectedRoleCount() {
			this.filteredRoles.forEach((module) => {
				if (module.roles.length > 0) {
					const allRolesSelected = module.roles.every((role) =>
						this.roles_array.includes(role.value)
					);
					module.roleView = allRolesSelected;
				} else {
					const allSubmodulesSelected = module.submodules.every((submodule) =>
						submodule.roles.every((role) =>
							this.roles_array.includes(role.value)
						)
					);
					module.roleView = allSubmodulesSelected;
				}
			});
		},
		roles_array: {
			handler() {
				this.updateSubmoduleViews();
			},
			deep: true,
		},
	},
	validations: {
		user: {
			name: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^[A-Za-z0-9 ]+$/),
			},
			emailid: {
				required,
				email,
				maxLength: maxLength(64),
			},
			roles: {
				landingPage: {
					required,
				},
			},
		},

		roleDropDownValue: {
			required,
		},
		rolesData: {
			roleName: {
				required,
				maxLength: maxLength(128),
				alphaSpecial: helpers.regex(
					"alphaSpecial",
					/^[a-z0-9·!@#$%^&*()\]\-_=~`{}|:;"'<>,.?\s]+$/i
				),
			},
			description: {
				maxLength: maxLength(250),
			},
		},
	},

	created() {
		this.LoaderStatus = true;
		this.getRolesDetails();
		this.getAccessData();
		this.$store.commit("searchVUEX/saveSearchTopicTest", "");
		this.setTabIndex();
	},
	methods: {
		checkRoleMatch(module) {
			if (module.roles && Array.isArray(module.roles)) {
				if (
					module.roles.some((role) =>
						role.text.toLowerCase().includes(this.searchTerm.toLowerCase())
					)
				) {
					return true;
				}
			}
		},
		filterRolesonSelectedFilter(filteredModules) {
			const filteredRoles = filteredModules
				.map((module) => {
					const filteredModule = { ...module };

					if (filteredModule.roles && Array.isArray(filteredModule.roles)) {
						filteredModule.roles = filteredModule.roles.filter((role) =>
							this.selectedFilter.includes(role.type)
						);
					}

					if (
						filteredModule.submodules &&
						Array.isArray(filteredModule.submodules)
					) {
						filteredModule.submodules = filteredModule.submodules
							.map((submodule) => {
								const filteredSubmodule = { ...submodule };

								if (
									filteredSubmodule.roles &&
									Array.isArray(filteredSubmodule.roles)
								) {
									filteredSubmodule.roles = filteredSubmodule.roles.filter(
										(role) => this.selectedFilter.includes(role.type)
									);
								}

								return filteredSubmodule;
							})
							.filter(
								(submodule) => submodule.roles && submodule.roles.length > 0
							);
					}

					return filteredModule;
				})
				.filter(
					(module) =>
						(module.roles && module.roles.length > 0) ||
						(module.submodules && module.submodules.length > 0)
				);

			return filteredRoles;
		},
		// Add role onselect colorchange methods.
		//     getAccessColorClass(item) {
		//   const roles =
		//     item.roles.length > 0
		//       ? item.roles
		//       : item.submodules.flatMap((submodule) =>
		//           submodule.roles ? submodule.roles : []
		//         );
		//   const hasSelectedRoles = roles.some((role) =>
		//     this.roles_array.includes(role.value)
		//   );
		//   return hasSelectedRoles ? "access-color" : "";
		// },
		// Set tabIndex based on the query variables (check watcher)
		setTabIndex() {
			if (this.$route.query.status == "roles") {
				this.tabName = this.$route.query.status;
			} else {
				this.tabName = "users";
			}
			switch (this.$route.query.status) {
				case "users":
					this.tabIndex = 0;
					break;
				case "roles":
					this.tabIndex = 1;
					break;
				default:
					this.tabIndex = 0;
			}
		},
		getAccessColorClass(item) {
			const roles =
				item.roles.length > 0
					? item.roles
					: item.submodules.flatMap((submodule) => submodule.roles);
			const hasSelectedRoles = roles.some((role) =>
				this.roles_array.includes(role.value)
			);
			return hasSelectedRoles ? "access-color" : "";
		},
		getAccessColorUpImage(item) {
			const roles =
				item.roles.length > 0
					? item.roles
					: item.submodules.flatMap((submodule) => submodule.roles);
			const hasSelectedRoles = roles.some((role) =>
				this.roles_array.includes(role.value)
			);
			return hasSelectedRoles
				? require(`../../assets/icons/whiteuparrow.svg`)
				: require(`../../assets/icons/uparrow.svg`);
		},
		getAccessColorDownImage(item) {
			const roles =
				item.roles.length > 0
					? item.roles
					: item.submodules.flatMap((submodule) => submodule.roles);
			const hasSelectedRoles = roles.some((role) =>
				this.roles_array.includes(role.value)
			);
			return hasSelectedRoles
				? require(`../../assets/whitedownarrow.svg`)
				: require(`../../assets/icons/access-drop-down.svg`);
		},
		updateSubmoduleViews() {
			this.filteredRoles.forEach((module) => {
				if (module.submodules != undefined) {
					module.submodules.forEach((submodule) => {
						submodule.submodView = this.areAllSubmoduleRolesSelected(submodule);
					});
				}
			});
		},
		areAllSubmoduleRolesSelected(submodule) {
			return submodule.roles.every((role) =>
				this.roles_array.includes(role.value)
			);
		},
		roleSearch() {
			document.querySelector("#headerSearch").placeholder = "Search Role";
		},
		usersSearch() {
			document.querySelector("#headerSearch").placeholder = "Search User";
		},
		// To Select dashboard based on Selected Roles
		selectMultipleRoles() {
			// Storing roles values in single array
			let storeRoleValues = [];
			for (let i in this.roleDropDownValue) {
				for (let j in this.roleDropDownValue[i].roles) {
					storeRoleValues.push(this.roleDropDownValue[i].roles[j]);
				}
			}
			// Creating new Set by removing duplicates of roles permission
			this.newRoleValues = [...new Set(storeRoleValues.map((item) => item))];

			//  Dashboard Roles Values
			const dashboard = {
				"Home (Default)": "GET_TOPIC",
				Admin: "VIEW_ADMIN",
				Evaluator: "GET_EVALUATOR_TEST",
			};

			// function to return matched values
			const arrayContainsAll = (dashboardValues, rolesValues) => {
				const arr = [];
				for (let i in dashboardValues) {
					if (rolesValues.indexOf(dashboardValues[i]) !== -1) {
						arr.push(i);
					}
				}
				return arr;
			};
			const res = arrayContainsAll(
				Object.values(dashboard),
				this.newRoleValues
			);

			const arr1 = [];
			for (let j in res) {
				arr1.push(Object.keys(dashboard)[res[j]]);
			}
			// Dashboard Values
			const options = [
				{ text: "Home (Default)", value: "/" },
				{ text: "Admin", value: "/permission/access" },
				{ text: "Evaluator", value: "/proctoring" },
			];

			this.dashboardOptions = [
				{ text: "Select Dashboard", value: "", disabled: true },
			];
			this.user.roles.landingPage = "";
			// assigning dashboard values based on permission selected
			for (let k in options) {
				if (arr1.indexOf(options[k].text) !== -1) {
					this.dashboardOptions.push(options[k]);
				}
			}
		},
		// Select Or All Roles vaules
		AllRolSelect() {
			if (this.selectAll) {
				this.addAllRolesToArray(this.filteredRoles);
			} else {
				this.roles_array = [];
			}
		},

		addAllRolesToArray(roles) {
			roles.forEach((role) => {
				this.addRolesFromArray(role.roles);

				if (role.submodules && role.submodules.length > 0) {
					role.submodules.forEach((submodule) => {
						this.addRolesFromArray(submodule.roles);
					});
				}
			});
		},

		addRolesFromArray(roles) {
			roles.forEach((role) => {
				if (!this.roles_array.includes(role.value)) {
					this.roles_array.push(role.value);
				}
			});
		},
		checkSelectAll() {
			let isSelectedAll = true;

			const checkRoles = (roles) =>
				roles.length > 0 &&
				!roles.every((role) => this.roles_array.includes(role.value));

			const processModule = (module) => {
				if (checkRoles(module.roles)) {
					isSelectedAll = false;
					return true;
				}

				if (module.submodules && Array.isArray(module.submodules)) {
					return !module.submodules.some((submodule) =>
						checkRoles(submodule.roles)
					);
				}

				return false;
			};

			isSelectedAll =
				this.filteredRoles.length !== 0
					? this.filteredRoles.every(processModule)
					: false;

			this.$nextTick(() => {
				this.selectAll = isSelectedAll;
			});
		},

		selectrole(module) {
			if (module.roleView) {
				this.selectRoles(module.roles);
				if (module.submodules) {
					module.submodules.forEach((submodule) => {
						this.selectRoles(submodule.roles);
					});
				}
			} else {
				this.deselectRoles(module.roles);
				if (module.submodules) {
					module.submodules.forEach((submodule) => {
						this.deselectRoles(submodule.roles);
					});
				}
			}
		},

		selectRoles(roles) {
			roles.forEach((role) => {
				if (!this.roles_array.includes(role.value)) {
					this.roles_array.push(role.value);
				}
			});
		},

		deselectRoles(roles) {
			roles.forEach((role) => {
				this.roles_array = this.roles_array.filter(
					(item) => item !== role.value
				);
			});
		},
		// selectrole(module) {
		//   if (module.roleView) {
		//     for (let k in module.roles) {
		//       if (!this.roles_array.includes(module.roles[k].value)) {
		//         this.roles_array.push(module.roles[k].value);
		//       }
		//     }
		//     if (module.submodules != undefined) {
		//       for (let l in module.submodules) {
		//         for (let m in module.submodules[l].roles) {
		//           if (
		//             !this.roles_array.includes(module.submodules[l].roles[m].value)
		//           ) {
		//             this.roles_array.push(module.submodules[l].roles[m].value);
		//           }
		//         }
		//       }
		//     }
		//   } else {
		//     for (let j in module.roles) {
		//       this.roles_array = this.roles_array.filter(function(item) {
		//         return item !== module.roles[j].value;
		//       });
		//     }
		//     for (let n in module.submodules) {
		//       for (let i in module.submodules[n].roles) {
		//         this.roles_array = this.roles_array.filter(function(item) {
		//           return item !== module.submodules[n].roles[i].value;
		//         });
		//       }
		//     }
		//   }
		// },
		selectSubRole(submodule) {
			if (submodule.submodView) {
				for (let j in submodule.roles) {
					if (!this.roles_array.includes(submodule.roles[j].value)) {
						this.roles_array.push(submodule.roles[j].value);
					}
				}
			} else {
				for (let i in submodule.roles) {
					this.roles_array = this.roles_array.filter(function(item) {
						return item !== submodule.roles[i].value;
					});
				}
			}
		},
		selectSubRolVal(subrole) {
			for (let k in subrole.roles) {
				if (!this.roles_array.includes(subrole.roles[k].value)) {
					this.roles_array.push(subrole.roles[k].value);
				} else {
					this.roles_array = this.roles_array.filter(function(item) {
						return item !== subrole.roles[k].value;
					});
				}
			}
		},
		selectRolVal(moduleroles) {
			for (let k in moduleroles.roles) {
				if (!this.roles_array.includes(moduleroles.roles[k].value)) {
					this.roles_array.push(moduleroles.roles[k].value);
				} else {
					this.roles_array = this.roles_array.filter(function(item) {
						return item !== moduleroles.roles[k].value;
					});
				}
			}
		},
		// Scroll to bottom when Add new User button is clicked
		// scrollToBottom() {
		//   this.$nextTick(() => {
		//     const scrollContainer = document.getElementById("scrollTobottomUser");
		//     const userCont = document.getElementById("addUserContainer");
		//     scrollContainer.scrollTo({
		//       top: scrollContainer.scrollHeight - userCont.offsetHeight,
		//       left: 0,
		//       behavior: "smooth",
		//     });
		//   });
		// },
		// scrollToBottomRole() {
		//   this.$nextTick(() => {
		//     const scrollContainer = document.getElementById("scrollTobottomRole");
		//     const roleCont = document.getElementById("addRoleContainer");
		//     scrollContainer.scrollTo({
		//       top: scrollContainer.scrollHeight - roleCont.offsetHeight,
		//       left: 0,
		//       behavior: "smooth",
		//     });
		//   });
		// },
		scrolltopUser() {
			const element = document.getElementById("scrollToUser");
			element.scrollTop = 0;
		},
		scrolltopRole() {
			const element = document.getElementById("scrollToRole");
			element.scrollTop = 0;
		},
		clearEditRoles() {
			this.roles_array = [];
			this.selectedFilter = [];
			this.searchTerm = "";
		},
		// Post User Api
		async addUser() {
			this.$v.user.$touch();
			this.$v.roleDropDownValue.$touch();
			if (this.$v.user.$error || this.$v.roleDropDownValue.$error) {
				this.errorToast("Please enter the details");
			} else if (!this.$v.user.$invalid || this.$v.roleDropDownValue.$invalid) {
				this.LoaderStatus = true;
				try {
					let payload = {
						email: this.user.emailid,
					};
					const res = await userToLicenseData(payload);
					if (res.status == 200) {
						let obj = {
							username: this.user.name,
							email: this.user.emailid,
							// roleName: this.user.roles.roleName,
							roles: this.roleDropDownValue.map((d) => d.roleName),
							landingPage: this.user.roles.landingPage,
							isActive: true,
						};
						let payloadOne = {
							project: "assessment",
							action: "add",
							licenseKey: this.licenseKey,
							userPermissions: [obj],
						};

						const response = await postAccessData(payloadOne);
						if (response.status == 200) {
							this.successToast("User Added Successfully!");
							this.addUserForm = false;
							this.getAccessData();
							this.scrolltopUser();
							this.LoaderStatus = false;
						} else if (response.status == 208) {
							this.LoaderStatus = false;
							this.errorToast(`User Already Exists for this EmailID`);
						} else {
							this.LoaderStatus = false;
							this.errorToast("Something went wrong!");
						}
						// return response;
					} else {
						this.errorToast("Something went wrong!");
						this.LoaderStatus = false;
						throw new Error(`Failed! Role Not Added`);
					}
				} catch (error) {
					this.LoaderStatus = false;
					throw new Error(`Adding User Failed! status: ${error.status}`);
				}
				this.clearUserFormData();
			}
		},

		// Get User Api
		async getAccessData() {
			this.LoaderStatus = true;
			try {
				let data = {
					user: "ALL",
					licensekey: this.licenseKey,
					searchQuery: this.searchTopicTest,
				};
				const res = await getAccessData(data);

				if (res.status == 200) {
					this.LoaderStatus = false;
					this.rowData = await res.data.data.Data;
					for (let i in this.rowData) {
						this.rowData[i].view = false;
					}
				}
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`Failed No Internet! status:${error.status}`);
			}
		},

		// Edit User Api
		async editUser() {
			this.$v.user.$touch();
			this.$v.roleDropDownValue.$touch();
			if (this.$v.user.$error || this.$v.roleDropDownValue.$error) {
				this.errorToast("Please enter the details");
			} else if (!this.$v.user.$invalid || this.$v.roleDropDownValue.$invalid) {
				let obj = {
					username: this.user.name,
					email: this.user.emailid,
					// roleName: this.user.roles.roleName,
					roles: this.roleDropDownValue.map((d) => d.roleName),
					landingPage: this.user.roles.landingPage,
					userID: this.selectedUserID,
					isActive: true,
				};

				let payload = {
					project: "assessment",
					action: "add",
					licenseKey: this.licenseKey,
					userPermissions: [obj],
				};
				try {
					const response = await putAccessData(payload);
					if (response.status == 200) {
						this.LoaderStatus = false;
						this.successToast("User Updated Successfully!");
						this.addUserForm = false;
						this.userStatus = "Add";
						this.updateEditUserData(payload);
					} else {
						this.errorToast("Something went wrong!");
					}
				} catch (error) {
					this.errorToast("Something went wrong!");
					throw new Error(`Failed! Updating Users! status: ${error.status}`);
				}
				this.clearUserFormData();
			}
		},
		// Delete User Api
		async deleteUser(data) {
			this.$bvModal.hide("delete-user-modal");
			let payload = {
				project: "assessment",
				userID: data.userID,
				licenseKey: this.licenseKey,
			};
			try {
				const response = await deleteAccessData(payload);
				if (response.status == 200) {
					this.LoaderStatus = false;
					this.removeDeleteUserData(data.email);
					this.successToast("User Deleted Successfully!");
				} else {
					this.errorToast("Something went wrong!");
				}
			} catch (error) {
				this.errorToast("Something went wrong!");
				throw new Error(`Failed! status:${error.status}`);
			}
		},

		copyEditUserData(row) {
			this.addUserForm = true;
			this.user["name"] = row.username;
			this.user["emailid"] = row.email;
			this.user.roles["roleName"] = row.roleName;
			this.selectedUserID = row.userID;
			this.userStatus = "Edit";
			for (let i in row.roles) {
				for (let j in this.rolesoptions) {
					if (row.roles[i] == this.rolesoptions[j].roleName) {
						let data = {};
						data = this.rolesoptions[j];
						data.project = "recruitment";
						this.roleDropDownValue.push(data);
						this.selectMultipleRoles();
					}
				}
			}
			this.user.roles["landingPage"] = row.landingPage;
		},

		copyEditRoles(data) {
			const result = data || this.storeData;
			this.rolecontainer = true;
			this.rolesData = JSON.parse(JSON.stringify(result));
			this.roles_array = JSON.parse(JSON.stringify(result.roles));
			this.roleStatus = "Edit";
		},
		closeTransition() {
			this.addUserForm = false;
			this.viewusercontainer = false;
			this.viewrolecontainer = false;
			this.rolecontainer = false;
			this.getRolesDetails();
			this.userStatus = "Add";
			this.roleStatus = "Add";
		},
		openUserDeleteModal(data) {
			this.deleteUserData = data;
			this.$bvModal.show("delete-user-modal");
		},

		GetRolesData(data) {
			for (let i in this.rolesoptions) {
				if (this.rolesoptions[i].roleName == data) {
					this.user["roles"].roleName = this.rolesoptions[i].roleName;
					this.user["roles"].description = this.rolesoptions[i].description;
					this.user["roles"].roles = this.rolesoptions[i].roles;
					this.user_array = this.rolesoptions[i].roles;
				}
			}
		},
		// Post roles
		postRoles() {
			this.$v.rolesData.$touch();
			if (this.roles_array.length != 0) {
				this.roles_options_checked = true;
			}
			if (!this.roles_array.length) {
				this.errorToast("Please select at least one access permission");
			} else if (this.$v.rolesData.roleName.$invalid) {
				this.errorToast("Please enter all the details");
			} else if (!this.$v.rolesData.$invalid && this.roles_options_checked) {
				this.rolesData["roles"] = this.roles_array;
				this.rolesData["licenseKey"] = this.licenseKey;
				this.rolesData["view"] = false;
				let data = this.rolesData;
				postRoles(data)
					.then((res) => {
						if (res.status == 200) {
							this.LoaderStatus = false;
							this.roleData.unshift(data);
							this.successToast("Role Added Successfully!");
							this.rolecontainer = false;
							this.roles_options_checked = false;
							this.scrolltopRole();
							this.pushtoRolesoptions(data);
							this.clearEditRoles();
							this.clearRolesFormData();
							this.$v.rolesData.$reset();
						} else {
							this.errorToast(`${res.data.data.Details}`);
						}
					})
					.catch((err) => {
						this.errorToast("Something went wrong!");
						throw err;
					});
			}
		},
		emailChange() {
			this.user.emailid = this.user.emailid.toLowerCase();
		},
		// Edit roles
		async editRoles() {
			if (!this.roles_array.length) {
				this.errorToast("Please select any one permissions");
			} else {
				this.rolesData["roles"] = this.roles_array;
				this.rolesData["projectPermission"] = "1";
				this.rolesData["licenseKey"] = this.licenseKey;
				let data = this.rolesData;
				try {
					const response = await putRoles(data);
					if (response.status == 200) {
						this.LoaderStatus = false;
						this.updateRoleData(data);
						this.successToast("Role Updated Successfully!");
						this.rolecontainer = false;
						this.roleStatus = "Add";
					} else {
						this.errorToast("Something went wrong!");
					}
				} catch (error) {
					this.errorToast("Something went wrong!");
					throw new Error(`Failed! Updating Roles:${error.status}`);
				}

				this.clearRolesFormData();
			}
		},
		// Get roles
		async getRolesDetails() {
			try {
				let payload = {
					licenseKey: this.licenseKey,
					searchQuery: this.searchTopicTest,
				};
				const res = await getRolesDetails(payload);
				if (res.status == 200) {
					this.roleData = await res.data.data.data;
					this.rolesoptions = res.data.data.data;
					this.LoaderStatus = false;
					for (let i in this.roleData) {
						this.roleData[i].view = false;
					}
				}
			} catch (error) {
				throw new Error(`Failed! status:${error.status}`);
			}
		},
		roleview(index) {
			for (let j in this.roleData) {
				this.roleData[j].view = false;
			}
			for (let i in this.roleData) {
				if (i == index) {
					this.roleData[i].view = true;
				}
			}
			this.$forceUpdate();
		},

		roleclose(index) {
			for (let i in this.roleData) {
				if (i == index) {
					this.roleData[i].view = false;
				}
			}
			this.$forceUpdate();
		},
		// Open Role Delete Modal
		openRoleDeleteModal(data) {
			this.deleteRolesData = data;
			this.$bvModal.show("delete-role-modal");
		},

		// Delete Roles Api
		async deleteRoles(data) {
			this.$bvModal.hide("delete-role-modal");
			try {
				let payload = {
					project: "assessment",
					roleName: data.roleName,
					licenseKey: this.licenseKey,
					description: data.description,
				};
				const response = await deleteRoles(payload);
				if (response.status == 200) {
					this.LoaderStatus = false;
					this.removeDeleteRoleData(data.roleName);
					this.successToast("Role Deleted Successfully!");
				} else if (response.status == 409) {
					let errorMessage = response.data.data.data;
					this.errorToast(`${errorMessage} cannot be deleted`);
				} else {
					this.errorToast("Something went wrong!");
				}
			} catch (error) {
				this.errorToast("Something went wrong!");
				throw new Error(`Failed! status:${error.status}`);
			}
		},

		// Update without page refresh, user role dropdown when roles updated
		pushtoRolesoptions(data) {
			let roleData = {};
			roleData["description"] = data.description;
			roleData["project"] = "assessment";
			roleData["roleName"] = data.roleName;
			roleData["roles"] = data.roles;
			this.rolesoptions.push(roleData);
		},

		// Update without page refresh user Data
		updateEditUserData(payload) {
			let data = payload.userPermissions[0];
			data["view"] = false;
			for (let i in this.rowData) {
				if (this.rowData[i].email == payload.userPermissions[0].email) {
					this.rowData[i].email = data.email;
					this.rowData[i].isActive = data.isActive;
					this.rowData[i].landingPage = data.landingPage;
					this.rowData[i].permissions = this.newRoleValues;
					this.rowData[i].roleName = data.roles.join(" + ").replace(/,/g, " ");
					this.rowData[i].roles = data.roles;
					this.rowData[i].userID = data.userID;
					this.rowData[i].username = data.username;
				}
			}
		},

		// remove delete role data from roleData array without reloading
		removeDeleteRoleData(payload) {
			this.roleData = this.roleData.filter((data) => data.roleName != payload);
			this.rolesoptions = this.rolesoptions.filter(
				(data) => data.roleName != payload
			);
		},
		// remove delete user data from rowData array without reloading
		removeDeleteUserData(payload) {
			this.rowData = this.rowData.filter((data) => data.email != payload);
		},

		// update edit data from roleData array without reloading
		updateRoleData(payload) {
			for (let i in this.roleData) {
				if (this.roleData[i].roleName === payload.roleName) {
					// Copying the OBJECT
					this.roleData[i] = { ...payload };
				}
			}
		},
		viewrole(data) {
			this.storeData = data;
			console.log(this.storeData, "storedata");
			this.viewrolecontainer = true;
			this.$forceUpdate();
		},
		viewUser(data) {
			this.storeuser = data;
			this.viewusercontainer = true;
		},
		filter() {
			this.filterview = !this.filterview;
		},
		hidefiltercard() {
			this.filterview = false;
		},
		rowview(row) {
			for (let i in this.rowData) {
				this.rowData[i].view = false;
			}
			for (let j in this.rowData) {
				if (this.rowData[j].userID == row.userID) {
					this.rowData[j].view = true;
				}
			}
			this.$forceUpdate();
		},
		rowclose(row) {
			for (let j in this.rowData) {
				if (this.rowData[j].userID == row.userID) {
					this.rowData[j].view = false;
				}
			}
			this.$forceUpdate();
		},

		// clearing user models
		clearRolesFormData() {
			this.$v.$reset();
			this.rolesData = {
				roleName: "",
				description: "",
				licenseKey: "",
				project: "assessment",
				projectPermission: "1",
				roles: [],
			};
			this.roles_array = [];
			this.searchTerm = "";
			this.selectedFilter = [];
		},

		// clearing role models
		clearUserFormData() {
			this.$v.$reset();
			this.user = {
				name: "",
				emailid: "",
				summary: "",
				roles: {
					roleName: "",
					description: "",
					roles: [],
					landingPage: "",
				},
			};
			this.$v.roleDropDownValue.$reset();
			this.$v.user.$reset();
			this.roleDropDownValue = [];
			this.selectedUserID = "";
			this.dashboardOptions = [
				{ text: "Select Dashboard", value: "", disabled: true },
			];
			this.newRoleValues = [];
		},
		roleDropdown() {
			this.selectroleview = !this.selectroleview;
		},
		hideroleDropdown() {
			this.selectroleview = false;
		},
		showDashboardText(data) {
			if (data == "/") {
				return "Home(default)";
			} else if (data == "/permission/access") {
				return "Admin";
			} else if (data == "/proctoring") {
				return "Evaluator";
			}
		},
	},
};
</script>
<style scoped>
.tab-container-ac {
	height: calc(100vh - 240px);
	overflow: auto;
}
.gridgreencolorDynamic {
	position: absolute;
	border-radius: 2px 1px 1px 2px;
	width: 3px;
	height: 90%;
	margin: auto;
	top: 2px;
	left: 3px;
}

.blur {
	filter: blur(2px);
}
</style>

<style>
.inputField {
	font-weight: 400;
	font-size: 12px;
	background: #fdfdfd;
	border: 0.7px solid rgba(114, 115, 142, 0.7);
	box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
	border-radius: 3px !important;
	z-index: 1;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.5rem 0.75rem 0.5rem 6px;
}
.recinput .form-control {
	padding: 0.375rem 1.3rem !important;
}
.access-searchicon-pos {
	position: absolute;
	top: 3px;
	left: 5px;
}
.accesspanel-cj-filter-modal {
	padding: 10px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	z-index: 6;
}
.cj-noofrecoption {
	color: #495057;
}
.rec-dd-group {
	width: 100%;
}

.error {
	font-size: 12px;
	border: 1px solid red !important;
}
.btn-position {
	position: absolute;
	top: 20px;
	right: 20px;
}

.acccard {
	height: 65vh !important;
	width: 92vw !important;
}
.acccolor {
	color: #333456 !important;
}
.userbtn {
	background-color: white !important;
	color: black !important;
}

.rolebtn {
	background-color: #e8e8e8 !important;
	color: black !important;
	box-shadow: 0px -4px 5px #c6c0d3;
}

.table-hover tbody tr:hover {
	background-color: white !important;
}

.btn-secondary:focus,
.btn-secondary.focus {
	box-shadow: none !important;
}

.btn:focus,
.btn.focus {
	box-shadow: none !important;
}
.select-roles-div {
	padding: 0.375rem 1.75rem 0.375rem 0.75rem !important;
}
.prevliage-text {
	font-weight: 400;
	font-size: 14px;
	color: #72738e;
}
.accesscontrol-role-main-container {
	position: absolute;
	width: 70%;
	height: calc(100vh - 80px);
	right: 0px;
	top: -5px;
	z-index: 5;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}
.slide-leave-active,
.slide-enter-active {
	transition: 0.5s;
}

.slide-enter {
	transform: translate(100%, 0);
}

.slide-leave-to {
	transform: translate(100%, 0);
}
.accesscontrol-backArrow {
	top: 2px;
	left: -29px;
}
.addrole-heading {
	font-weight: 600;
	font-size: 18px;
	color: #464667;
}
.access-outerbox {
	font-weight: 500;
	font-size: 14px;
	color: #6d6d6d;
	padding: 15px;
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}
.accesscontrol-modulecards {
	background: #ffffff;
	border: 1px solid rgba(114, 115, 142, 0.5);
	border-radius: 5px;
	padding: 15px;
}
.access-submodulecards {
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 15px;
	border-top: 1px solid #e2e2e2;
}
.access-opened-box {
	background: #fdfdfd;
	border: 0.7px solid rgba(114, 115, 142, 0.7);
	box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	padding: 4px;
	margin: 10px;
	font-weight: 400;
	font-size: 12px;
	color: #545454;
}
.partial-select .custom-switch .custom-control-label::after {
	background-color: #83aace !important ;
}
.role-switch-label {
	color: #545454;
	font-weight: 400;
	font-size: 14px;
}
.access-color {
	background: #83aace;
	color: #ffffff;
}
.access-color .custom-control-label {
	color: #ffffff;
}
.access-color .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-color: #ffffff !important;
	background-color: #4b80af !important;
}
.access-color-full {
	background: #4b80af;
	color: #ffffff;
}
.access-color-fullmain {
	background: #4b80af;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
	display: none;
}
.accesscontrol-opened-br {
	border-radius: 0px 0px 5px 5px !important;
}
.accesscontrol-closed-br {
	border-radius: 5px !important;
}
.prvilagetxt {
	font-weight: 500;
	font-size: 14px;
	color: #464667;
}
.previlagesubtxt {
	font-weight: 400;
	font-size: 14px;

	color: #72738e;
}
.newuserdesign .custom-switch {
	padding-top: 1rem;
}
.topDiv > .modaldisableinputField {
	font-family: "Poppins", sans-serif;
	background: #fdfdfd;
	border: 0.7px solid #bbbbbb;
	padding: 5px 10px;
	border-radius: 3px !important;
}
.topDiv > .access-disableinput {
	background: #b8b8b8;
	opacity: 0.2;
	color: black;
	border: 1px solid #0a56c8;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
}
.access-control-filterbox {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 95px;
	text-align: center;
}
.search-position {
	position: absolute;
	top: 11px;
	left: 8px;
}
.cj-filter-modal {
	padding: 10px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
	border-radius: 5px;
	z-index: 6;
	position: absolute;
	width: 317px;
	height: 180px;
	right: 15px;
	top: 93px;
}
.acess-cj-filter-modal {
	padding: 10px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	z-index: 6;
	position: absolute;
	width: 100%;
}
.access-validationicon {
	position: absolute;
	top: 4px;
	right: 12px;
}
.custom-select {
	background: none;
}
.topDiv > .disable-inputField {
	font-family: "Poppins", sans-serif;
	border: 1px solid #bbbbbb;
	border-radius: 3px !important;
	font-size: 14px;
	color: #6d6d6d;
	box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
	box-sizing: border-box;
}
.topDiv > .disable-fieldsetStyle {
	color: var(--bg-tertiary);
	background: #f4f4f4;
	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-size: var(--size-10);
	line-height: 18px;
	z-index: 4;
	padding-left: 6px;
	padding-right: 4px;
}
.disable-div {
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.375rem 0.75rem;
	background-color: #e9ecef;
}
.access-font-color {
	font-size: 15px;
	font-weight: 500;
	color: #696969;
}

/* new table design starts from here */

.access-control-sub-container {
	height: calc(100vh - 138px);
	overflow: auto;
	margin-top: 15px;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
	border-radius: 10px;
}

.userAccess-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 242px);
	overflow-x: auto;
	overflow-y: hidden;
}

.userAccess-table-head {
	min-width: 1000px;
	max-width: 100%;
	display: flex;
	align-items: center;
	padding: 10px 20px;
	background: hsla(0, 0%, 76.9%, 0.5);
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	color: #696969;
}

.userAccess-table-body {
	min-width: 1000px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 277px);
}

.userAccess-table-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	border: 0.5px solid #e5e5e5;
	background: #fafafa;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 20px 20px;
	margin: 10px 0px;
}

.userAccess-table-row:hover {
	background: #e7e8f5;
}

.userAccess-first-col {
	width: 25%;
}

.userAccess-second-col {
	width: 30%;
}

.userAccess-third-col {
	width: 20%;
}

.userAccess-fourth-col {
	width: 15%;
}

.userAccess-fifth-col {
	width: 10%;
}

.roleAccess-first-col {
	width: 40%;
}

.roleAccess-second-col {
	width: 50%;
}

.roleAccess-third-col {
	width: 10%;
}
</style>
